// Shared presentation: native facets and document actions retain their owners.
(function (window, $) {
  'use strict';
  var geometryPending = false;
  var geometryTargets = new WeakSet();
  var geometryObserver = window.ResizeObserver ? new ResizeObserver(scheduleGeometry) : null;
  function scheduleGeometry() {
    if (geometryPending) return;
    geometryPending = true;
    window.requestAnimationFrame(function () {
      geometryPending = false;
      var title = document.querySelector('.t-Body-title');
      var header = document.querySelector('.t-Header');
      [title, header].forEach(function (element) {
        if (element && geometryObserver && !geometryTargets.has(element)) {
          geometryTargets.add(element); geometryObserver.observe(element);
        }
      });
      var offset = header ? header.getBoundingClientRect().height : 0;
      if (title) {
        var style = window.getComputedStyle(title);
        if (style.position === 'sticky' || style.position === 'fixed') {
          var top = parseFloat(style.top);
          offset = Math.max(offset, (isNaN(top) ? offset : top) + title.getBoundingClientRect().height);
        }
      }
      var value = Math.ceil(offset) + 'px';
      document.querySelectorAll('.t-Body-actions:has([id$="_fr"])').forEach(function (panel) {
        if (panel.style.getPropertyValue('--lp-filter-sticky-top') !== value) {
          panel.style.setProperty('--lp-filter-sticky-top', value);
        }
      });
    });
  }
  function decorate() {
    var hr = /^hr(?:-|$)/i.test(document.documentElement.lang || '');
    document.querySelectorAll('.a-FS').forEach(function (facets) {
      var region = facets.closest('.t-ContentBlock,.t-Region') || facets.closest('.js-apex-region');
      if (!region) return;
      var heading = region.querySelector('.t-ContentBlock-title,.t-Region-title');
      if (heading && /^(?:facet(?:ed)?\s+search|search\s+facets|filters?\s+and\s+sorts|filters?|search)$/i.test(heading.textContent.trim())) {
        heading.textContent = hr ? 'Filtri' : 'Filters';
      }
    });
    scheduleGeometry();
    document.querySelectorAll('.t-Drawer-footer nav.t-Button--dropdown,.t-Dialog-footer nav.t-Button--dropdown').forEach(function (button) {
      button.tabIndex = 0;
      button.setAttribute('role', 'button');
      button.setAttribute('aria-haspopup', 'menu');
      var label = button.querySelector('.t-Button-label');
      if (label) button.setAttribute('aria-label', label.textContent.trim());
      button.querySelectorAll('li[onclick]').forEach(function (item) {
        if (item.dataset.lpKeyboard) return;
        item.dataset.lpKeyboard = 'true';
        item.tabIndex = 0;
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); item.click(); }
        });
      });
    });
  }
  $(function () {
    decorate();
    $(document).off('.lpCompactFilters').on('apexafterrefresh.lpCompactFilters apexreadyend.lpCompactFilters', decorate);
    $(window).off('resize.lpCompactFilters').on('resize.lpCompactFilters', scheduleGeometry);
  });
})(window, apex.jQuery);
